export default "__VITE_ASSET__D_lvtA9M__";